// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topModule {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.arrows {
  display: inline-flex;
  align-items: center;
}

.adhoc-modules .ant-form-item {
  box-shadow: 0px 0px 35px -10px rgba(0, 0, 0, 0.4) !important;
  padding: 20px;
  border-radius: 20px;
  margin: 10px;
}

.ant-form-item.no-box-shadow {
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/adhoc/Modules.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;EAC5D,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".topModule {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.arrows {\n  display: inline-flex;\n  align-items: center;\n}\n\n.adhoc-modules .ant-form-item {\n  box-shadow: 0px 0px 35px -10px rgba(0, 0, 0, 0.4) !important;\n  padding: 20px;\n  border-radius: 20px;\n  margin: 10px;\n}\n\n.ant-form-item.no-box-shadow {\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
